export default __webpack_public_path__ + "static/media/autre.2427a262.png";